import { Axios } from 'common/services';
import { IPageResult, IProject, IExpertReview } from 'common/models';

const getProjects = async (
  queryString: string
): Promise<IPageResult<IProject>> =>
  (await Axios.get(`/Admin/projects?${queryString}`)).data;

export const validateProject = async (
  projectId: string,
  payload: Pick<IExpertReview, 'comment' | 'ratings'>
) => await Axios.put(`/Project/${projectId}/validate`, payload);

export const rejectProject = async (projectId: string) =>
  await Axios.put(`/Project/${projectId}/rejected`);

export default {
  getProjects,
  rejectProject,
  validateProject
};
